<div fxLayout="column" style="height: 85vh">
   <img
      fxFlex="1 2 0"
      [src]="logoPath$ | async"
      class="sam-login-logo"
      style="margin: 0 auto 2em auto; display: block"
      border="0"
      width="128px"
      height="128px"
   />
   <div fxFlex="1 2 0" class="welcome-text-box">
      {{ translatedWelcomeText$ | async }}
   </div>
   <div
      fxFlex="1 2 0"
      class="k-form-field k-form-field-with-icon sam-full-width sam-margin"
      *ngIf="(allAcdExtensions$ | async).length > 3 || (searchValue$ | async).length > 0"
   >
      <fa-icon class="snc-input-icon snc-input-icon-right" [icon]="searchIcon"></fa-icon>
      <input
         samwebAutoFocus
         [value]="searchValue$ | async"
         (input)="searchTextChanged($event.target.value)"
         placeholder="{{ 'common.search-text' | translate }}"
         kendoTextBox
         class="acd-search-textbox"
      />
   </div>

   <div fxFlex="1 1 100%" class="acd-extension-container">
      <div
         *ngFor="let acdExtension of getFilteredAcdExtensionForSelection$ | async"
         class="acd-extension-item sam-padding"
         [ngClass]="acdExtension.isAvailable ? 'acd-extension-available' : 'acd-extension-non-available'"
         (click)="selectAcdExtension(acdExtension)"
         fxLayout="row"
      >
         <div class="acd-extension-type-icon" fxFlex="0 0 auto" fxFlexAlign="center">
            <fa-icon [icon]="(acdExtension.acdLine | toAcdType).icon" [fixedWidth]="true"></fa-icon>
         </div>

         <div class="acd-extension-details" fxFlexAlign="center" fxFlex="1 1 100%">
            <div class="acd-extension-name">
               {{ acdExtension.name }}
            </div>
            <div class="acd-extension-number">
               {{ acdExtension | acdExtensionToAcdNumber$ | async }}
            </div>
         </div>

         <div
            class="occupied-info-container acd-extension-type-icon"
            fxFlex="0 0 auto"
            fxFlexAlign="center"
            *ngIf="acdExtension.userAcdOccupiedByUserInfo"
         >
            {{ acdExtension.userAcdOccupiedByUserInfo?.occupiedByUserName }}
         </div>
      </div>
   </div>
   <div fxFlex="1 2 0" fxLayout="row" fxLayoutAlign="space-around">
      <div fxLayout="column" class="logout-container" (click)="signOut()">
         <fa-icon fxLayoutAlign="center" [icon]="signOutIcon"></fa-icon>
         <span>{{ 'navigation.homebar.logout_button' | translate }}</span>
      </div>
   </div>
</div>
